<template>
  <div>
    <div
      class="d-flex pr-4"
    >
      <v-spacer />

      <v-btn
        class="rounded-b-0"
        :color="isInEditorMode ? 'secondary' : 'transparent'"
        depressed
        small
        @click="showEditor"
      >
        Editor
      </v-btn>

      <v-btn
        class="rounded-b-0"
        :color="isInPreviewMode ? 'secondary' : 'transparent'"
        depressed
        small
        @click="showPreview"
      >
        Preview
      </v-btn>
    </div>

    <v-textarea
      v-show="isInEditorMode"
      ref="textEditor"
      v-model="markdownContent"
      auto-grow
      hide-details
      label="Comment"
      outlined
    />

    <v-sheet
      v-show="isInPreviewMode"
      outlined
      rounded
      class="px-3 pt-3 pb-1 text-body-1"
      :legal-case-id="legalCaseId"
    >
      <DocketEntryCommentViewer
        v-model="markdownContent"
        :legal-case-id="legalCaseId"
      />
    </v-sheet>

    <p
      v-show="isInEditorMode"
      class="mt-1"
    >
      Comment field supports basic
      <a
        href="https://www.markdownguide.org/basic-syntax"
        target="_blank"
        class="font-weight-bold"
      >
        Markdown
      </a>
    </p>
  </div>
</template>

<script>
import DocketEntryCommentViewer from '@/components/DocketEntry/CommentViewer'

export default {
  name: 'DocketEntryEditorComment',

  components: {
    DocketEntryCommentViewer,
  },

  model: {
    prop: 'comment',
    event: 'change',
  },

  props: {
    comment: {
      type: String,
      default: '',
    },

    legalCaseId: {
      type: Number,
      default: undefined,
    },
  },

  data () {
    return {
      docketInfoCache: undefined,
      previewMode: false,
    }
  },

  computed: {
    isInEditorMode () {
      return !this.previewMode
    },

    isInPreviewMode () {
      return this.previewMode
    },

    markdownContent: {
      get () {
        return this.comment || ''
      },

      set (value) {
        this.$emit('change', value)
      },
    },
  },

  methods: {
    showEditor () {
      this.previewMode = false
    },

    showPreview () {
      this.previewMode = true
    },
  },
}
</script>
